export const EventConst = {
  Error: 'error',
  Analytics: 'analytics',
  Metrics: 'metrics',
  System: 'system',
} as const;
